import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PromocionResumen } from 'src/app/model/promotion-models-v2';
import { CommissionPromotionsV2Service } from 'src/app/services/commission-promotions-v2.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-configurador-v2',
  templateUrl: './configurador-v2.component.html',
  styleUrls: ['./configurador-v2.component.css']
})
export class ConfiguradorV2Component implements OnInit, AfterViewInit {
  // Estado página
  public viewStatus = 0; // -1:nada, 0:spinner, 1:tabla

  displayedColumns: string[] = [
    'promocionId',
    'nombrePromocion',
    'fechaVigenciaInicio',
    'fechaVigenciaFin',
    'tipoConfiguracionId',
    'fechaCreacion',         // ← antes 'createDate'
    'status',
    'acciones'
  ];

  dataSource: MatTableDataSource<PromocionResumen>;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  //Propiedades para el manejo del componente de creacion de configuracion
  public showConfigModal = false;
  public configMode = '';
  public selectedPromotionId = 0;
  public filterValue: string = '';

  constructor(
    private commissionPromotionsService: CommissionPromotionsV2Service,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private router: Router
  ) {
    this.dataSource = new MatTableDataSource<PromocionResumen>([]);
  }

  ngOnInit() {
    this.getCatalogs();
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (this.paginator && this.sort) {
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        this.dataSource.sortingDataAccessor = (item: PromocionResumen, property: string) => {
          switch (property) {
            case 'estructuraNombre':
              return item.estructuraNombre;
            case 'fechaVigenciaInicio':
              return new Date(item.fechaVigenciaInicio).getTime();
            case 'fechaVigenciaFin':
              return new Date(item.fechaVigenciaFin).getTime();
            case 'fechaCreacion':
              return new Date(item.fechaCreacion).getTime();
            case 'status':
              return this.activeStatus(item);
            default:
              return item[property];
          }
        };
      }
    });
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = this.filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  // Metodos para el manejo del componente de creacion de configuracion

  add = () => {
    this.router.navigate(['/promociones/configurador-promociones-v2'], {
      queryParams: { mode: 'add', promotionId: 0 }
    });
  };

  edit = (item: PromocionResumen) => {
    this.router.navigate(['/promociones/configurador-promociones-v2'], {
      queryParams: { mode: 'edit', promotionId: item.promocionId }
    });
  };

  consult = (item: PromocionResumen) => {
    this.router.navigate(['/promociones/configurador-promociones-v2'], {
      queryParams: { mode: 'consult', promotionId: item.promocionId }
    });
  };

  // Manejar el cierre del componente hijo
  onModalClosed(reason: string) {
    this.showConfigModal = false;

    if (reason !== 'cancel') {
      this.viewStatus = 0;
      this.getCatalogs();
    } else {
      setTimeout(() => {
        if (this.paginator && this.sort) {
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
        }
      });
    }
    // ← Limpiar filtro siempre
    this.filterValue = '';
    this.dataSource.filter = '';
  }

  getCatalogs = () => {
    this.commissionPromotionsService.getAllPromotions().subscribe(
      (resp) => {
        console.log(resp);
        if (resp.httpStatusCode === 200) {
          this.dataSource.data = resp.data;
          this.viewStatus = 1;

          setTimeout(() => {
            if (this.paginator && this.sort) {
              this.dataSource.paginator = this.paginator;
              this.dataSource.sort = this.sort;

              // ← Campos actualizados al nuevo modelo PromocionResumen
              this.dataSource.sortingDataAccessor = (item: PromocionResumen, property: string) => {
                switch (property) {
                  case 'estructuraNombre':
                    return item.estructuraNombre;
                  case 'fechaVigenciaInicio':
                    return new Date(item.fechaVigenciaInicio).getTime();
                  case 'fechaVigenciaFin':
                    return new Date(item.fechaVigenciaFin).getTime();
                  case 'fechaCreacion':
                    return new Date(item.fechaCreacion).getTime();
                  case 'status':
                    return this.activeStatus(item);
                  default:
                    return item[property];
                }
              };

              // ← Filtro por campos del nuevo modelo
              this.dataSource.filterPredicate = (item: PromocionResumen, filter: string) => {
                const searchStr = [
                  item.nombrePromocion,
                  item.estructuraNombre,
                  item.tipoConfiguracion,
                ].join(' ').toLowerCase();
                return searchStr.includes(filter);
              };
            }
          });
        } else {
          this.viewStatus = -1;
          this.toastr.error(resp.messageError || 'Ocurrió un error al obtener la información');
        }
      },
      (error) => {
        console.error(error);
        this.viewStatus = -1;
        this.toastr.error('Ocurrió un error al obtener la información');
      }
    );
  };

  toggleActivePromotion = (catPromotion: PromocionResumen) => {
    this.commissionPromotionsService
      .toggleActivePromotion(catPromotion)
      .subscribe(
        (resp) => {
          console.log(resp);
          if (resp.httpStatusCode == 200) {
            catPromotion.activoId = resp.data.activoId;
            this.toastr.info(
              'Se ha cambiado el estado de la promoción ' +
              catPromotion.nombrePromocion +
              ' y ahora esta en status: ' +
              (catPromotion.activoId == 1 ? 'Activo' : 'Inactivo')
            );
            // Refrescar la tabla
            this.dataSource.data = [...this.dataSource.data];
          } else {
            this.toastr.error(
              'Ocrurrio algun error y no se logro activar/desactivar la promoción'
            );
          }
        },
        (error) => {
          console.log(error);
          this.toastr.error(
            'Ocrurrio algun error, no se logro activar/desactivar la promoción'
          );
        }
      );
  };

  activeStatus(promocion: PromocionResumen): number {
    if (promocion.activoId !== 1) return -1;
    const ahora = Date.now();
    const desde = Date.parse(promocion.fechaVigenciaInicio);
    const hasta = Date.parse(promocion.fechaVigenciaFin);
    return hasta >= ahora && desde <= ahora ? 1 : 0;
  }

  clonePromotion(promocion: PromocionResumen) {
    this.viewStatus = 0;
    this.commissionPromotionsService
      .clonarPromocion(promocion.promocionId)
      .subscribe(
        (resp) => {
          if (resp.httpStatusCode === 200) {
            this.toastr.success(
              'La promoción se clonó correctamente, ID: ' + resp.data.promocionId
            );
            this.getCatalogs(); // ← recargar tabla completa
          } else {
            this.toastr.error('Ocurrió algún error al intentar clonar la promoción');
          }
          this.viewStatus = 1;
        },
        (error) => {
          console.error(error);
          this.toastr.error('Ocurrió algún error al intentar clonar la promoción');
          this.viewStatus = 1;
        }
      );
  }

  verHistorial = (item: PromocionResumen) => {
    this.router.navigate(['/promociones/consulta-historico-configuracion-v2'], {
      queryParams: { promotionId: item.promocionId, promotionName: item.nombrePromocion }
    });
  }

}
